import React from 'react';
import styles from './keyboard-input.module.css';
import { useViewModel } from './useViewModel';

/**
 * KeyboardInput component for single-character pad and bulk input.
 * @param {Object} props
 * @param {Object} props.group - The group object (for price, etc)
 * @param {string} props.slotId - The slot ID for updating selections
 * @param {number} props.maxLength - Maximum allowed characters
 */
export const KeyboardInput = ({ group, slotId, maxLength = 10 }) => {
  const {
    inputValue,
    handleInputChange,
    handleInputKeyDown,
    handleApply,
    maxLength: max,
    priceLabel
  } = useViewModel({ group, slotId, maxLength });

  return (
    <div className={styles['keyboard-input']}>
      <div className={styles['keyboard-input__header']}>
        <span className={styles['keyboard-input__title' + ' body-base font-medium']}>
          {group.uiHeading || group.internalName}
        </span>
        {priceLabel && <span className={styles['keyboard-input__price'] + ' body-sm'}>{priceLabel}</span>}
      </div>
      <div className={styles['keyboard-input__input-container']}>
        <div className={styles['keyboard-input__input-wrapper']}>
          <input
            id={`letters-input-${slotId}`}
            className={styles['keyboard-input__input'] + ' field__input'}
            type="text"
            maxLength={max}
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleInputKeyDown}
            enterKeyHint="done"
            placeholder="Type name, initials or message"
            aria-label="Type name, initials or message"
          />
          <p className={styles['keyboard-input__input-length'] + ' body-xs'}>
            {inputValue.length}/{max}
          </p>
        </div>
        <button
          className={styles['keyboard-input__apply'] + ' button button--primary button--orange'}
          type="button"
          onClick={handleApply}
          aria-label="Apply initial letters"
        >
          Apply
        </button>
      </div>
    </div>
  );
};
